import { Controller } from "@hotwired/stimulus"

// Instance creation form. Two setup paths: the AllSpark (prefab) template or a
// pre-built stack. Both are baked into their snapshots; provisioning never
// creates or clones a GitHub repository — that happens during instance setup.
export default class extends Controller {
  static targets = [
    "workspaceSelect", "templateTypeField", "codeSourceField",
    "dropletSizeSelect",
    "setupCard", "stackFields", "stackTemplateRadio",
    "templateRepoInfo"
  ]
  static values = {
    workspaceRepos: Object,  // { workspace_id: { url, repoUrl, branch } } — informational only
    templates: Object        // { slug: { name, description, icon, skipGithubSetup, defaultSize } }
  }

  connect() {
    this.syncHiddenFields()
  }

  // ─── Setup Method ───

  get selectedSetupMethod() {
    const checked = this.element.querySelector('input[name="setup_method"]:checked')
    return checked ? checked.value : "allspark_template"
  }

  setupMethodChanged() {
    const method = this.selectedSetupMethod

    if (this.hasStackFieldsTarget) {
      if (method === "prebuilt_stack") {
        this.stackFieldsTarget.classList.remove("hidden")
      } else {
        this.stackFieldsTarget.classList.add("hidden")
      }
    }

    this.syncHiddenFields()
  }

  // Sync hidden form fields (template_type and code_source) based on selection
  syncHiddenFields() {
    const method = this.selectedSetupMethod

    if (method === "prebuilt_stack") {
      const selectedStack = this.element.querySelector('input[name="prebuilt_template"]:checked')
      const slug = selectedStack ? selectedStack.value : "pern"
      this.templateTypeFieldTarget.value = slug
      this.codeSourceFieldTarget.value = "template"
      this.updateDropletSize(slug)
    } else {
      this.templateTypeFieldTarget.value = "prefab"
      this.codeSourceFieldTarget.value = "template"
      this.updateDropletSize("prefab")
    }
  }

  stackTemplateChanged() {
    this.syncHiddenFields()
  }

  updateDropletSize(templateSlug) {
    const template = this.templatesValue[templateSlug]
    if (this.hasDropletSizeSelectTarget && template && template.defaultSize) {
      this.dropletSizeSelectTarget.value = template.defaultSize
    }
  }

  // ─── Workspace ───

  workspaceChanged() {
    // Nothing repo-related depends on the workspace any more; kept as the
    // change handler the select points at.
  }
}
